import React from 'react';
// Import FontAwesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus, faIdCard, faListOl, faTasks, faDollarSign } from '@fortawesome/free-solid-svg-icons';

const PaymentRequestModal = ({
    isOpen,
    onClose,
    paymentRequestDetails,
    onNavigateToPaymentRequest,
    onAddNewPaymentRequest,
    trafficReference
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" aria-hidden="true"></div>
                
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full">
                    <div className="bg-blue-50 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">
                            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                                {/* Optional icon or image */}
                            </div>
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                    Payment Request Details
                                </h3>
                                <div className="mt-2">
                                    {/* Grid Header */}
                                    <div className="grid grid-cols-6 gap-4 font-bold text-blue-600 mb-2 text-center">
                                        <div className="col-span-2">ID <FontAwesomeIcon icon={faIdCard} /></div>
                                        <div>Priority <FontAwesomeIcon icon={faListOl} /></div>
                                        <div>Status <FontAwesomeIcon icon={faTasks} /></div>
                                        <div className="col-span-2">Total to Pay <FontAwesomeIcon icon={faDollarSign} /></div>
                                    </div>
                                    {/* Grid Rows with Alternating Background and centered text */}
                                    {paymentRequestDetails.map((request, index) => (
                                        <div key={request._id} className={`grid grid-cols-6 gap-4 ${index % 2 === 0 ? 'bg-blue-100' : 'bg-blue-200'} rounded-lg p-2 text-center`}>
                                            <div className="col-span-2">
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault(); 
                                                    onNavigateToPaymentRequest(request, trafficReference);
                                                }} className="hover:text-blue-800 font-semibold">
                                                    {request._id}
                                                </a>
                                            </div>
                                            <div>{request.priority}</div>
                                            <div>{request.status}</div>
                                            <div className="col-span-2">${request.total_to_pay}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-blue-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                        <button onClick={onClose} type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                            <FontAwesomeIcon icon={faTimes} className="mr-2" /> Close
                        </button>
                        <button onClick={onAddNewPaymentRequest} type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm">
                            <FontAwesomeIcon icon={faPlus} className="mr-2" /> Add New Payment Request
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentRequestModal;
